import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

const baseUrl = environment.backendurl;



@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  public fetchDatafromDate: Subject<any> = new Subject(); 

  constructor(private http: HttpClient) { }
  
    //get Candidate List  
    getAllReportsCount(data){

      data = GlobalService.buildQueryString(data)
      let url = baseUrl + `/reports/allreportcounts?${data}`
      return this.http.get(url).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('Get Candidate List', url)))
    }
  

    getActivityDetails(data){

      data = GlobalService.buildQueryString(data)
      let url = baseUrl + `/reports/activitydetails?${data}`
      return this.http.get(url).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('Get Candidate List', url)))
      
    }

    getActivityBreakDown(data){

      data = GlobalService.buildQueryString(data)
      let url = baseUrl + `/reports/activitybreakdown?${data}`
      return this.http.get(url).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('Get Candidate List', url)))
    }
  
    
    getCreditUsage(data){
      data = GlobalService.buildQueryString(data)
      let url = baseUrl + `/reports/creditusage?${data}`
      return this.http.get(url).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('Get Candidate List', url)))
    }

    

    
  
public createDataWithDate (): void {
  this.fetchDatafromDate.next();
}

public fetchDataWithDate (): Observable<any> {
  return this.fetchDatafromDate.asObservable();
}
}
